import Translated from '../Translated';
import { useTranslation } from '../TranslationProvider';

const AssessmentInstructions = ({ category, assessment }) => {
  const { translate } = useTranslation();
  if (!assessment?.localizationKeys || !Array.isArray(assessment.topics) || assessment.category !== category?.toLowerCase()) {
    return null;
  }

  return (
    <div className="blue-box mb-3 text-start">
      <h4><Translated translationKey={assessment.localizationKeys.title} /></h4>
      <p><Translated translationKey={assessment.localizationKeys.instructions} values={{ total: assessment.totalQuestionAmount, required: assessment.totalPassLimit }} /></p>
      <ul>
        {assessment.topics.map(topic => (
          <li key={topic.id}>
            {translate(topic.localizationKey)}: <Translated translationKey={assessment.localizationKeys.topicRequirement} values={{ questions: topic.questionAmount, required: topic.passLimit }} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AssessmentInstructions;
